import { defineMessages } from '@jutro/locale';

export default defineMessages({
    effectiveDate :{
        id: 'ml.gateway.views.completedTransactions.Effective Date',
        defaultMessage: 'EFFECTIVE DATE'
    },
    premiumChange :{
        id: 'ml.gateway.views.completedTransactions.Premium Change',
        defaultMessage: 'PREMIUM CHANGE'
    },
    description :{
        id: 'ml.gateway.views.completedTransactions.Description',
        defaultMessage: 'DESCRIPTION'
    },
    initiator :{
        id: 'ml.gateway.views.completedTransactions.Initiator',
        defaultMessage: 'INITIATOR'
    },
    details :{
        id: 'ml.gateway.views.completedTransactions.Details',
        defaultMessage: 'DETAILS'
    },
    insured :{
        id: 'ml.gateway.views.completedTransactions.Insured',
        defaultMessage: 'Insured'
    },
    agent :{
        id: 'ml.gateway.views.completedTransactions.Agent',
        defaultMessage: 'Agent'
    },
    dash :{
        id: 'ml.gateway.views.completedTransactions.$-',
        defaultMessage: '$-'
    },
    compareTerm :{
        id: 'ml.gateway.views.completedTransactions.Compare Term',
        defaultMessage: 'COMPARE TERM'
    },
    detailsLabel: {
        id: 'ml.gateway.views.completedTransactions.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    detailsHelpMsg: {
        id: 'ml.gateway.views.completedTransactions.Click to compare selected transaction to prior transaction.',
        defaultMessage: 'Click to compare selected transaction to prior transaction.'
    },
    compare: {
        id: 'ml.gateway.views.completedTransactions.Compare',
        defaultMessage: 'Compare'
    }
});
